// extracted by mini-css-extract-plugin
export var actionButton = "_8k-0";
export var attachmentLine = "_8k-1";
export var fileInput = "_8k-2";
export var fileUploadWrapper = "_8k-4";
export var footer = "_8k-3";
export var modalContent = "_8k-5";
export var paperclip = "_8k-6";
export var quillEditor = "_8k-7";